<template lang="html">
  <el-row class="p-login container">
    <el-row class="login-wrap">
      <el-row class="login-con">
        <el-row class="login-logo">
          <img src="../assets/logo-fw.svg" alt="" width="72px" class="logo">
        </el-row>
        <el-form v-model="form" ref="form" class="login-form">
          <el-form-item prop="username">
            <el-input :placeholder="$t('common.usernamePlaceholder')" v-model="form.username"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input type="password" :placeholder="$t('common.passwordPlaceholder')" v-model="form.password" @keyup.enter.native="login"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              @click="login"
              size="large"
              type="primary">
              {{ $t('common.login') }}
            </el-button>
          </el-form-item>

          <el-form-item style="text-align:center">
            <el-button
              @click="loginByWeixin"
              size="large"
              type="text">
              {{ $t('pages.login.WeixinLogin') }}
            </el-button>
          </el-form-item>
          <el-form-item style="text-align:center">
            <el-button
              @click="redirectForgotPassword"
              size="large"
              type="text">
              {{ $t('pages.login.ForgotPassword') }}
            </el-button>
          </el-form-item>
        </el-form>
      </el-row>
    </el-row>
  </el-row>
</template>

<script>
  import { Message } from 'element-ui';

  export default {
    data() {
      return {
        app_key: 'qZkZT5WZSdirdcL88wyRx5pN8tsyaqAi',
        form: {
          app_key: 'qZkZT5WZSdirdcL88wyRx5pN8tsyaqAi',
          username: '',
          password: '',
        },
        weixinParam: {
          app_key: 'qZkZT5WZSdirdcL88wyRx5pN8tsyaqAi',
          return_url: 'http://hamlet.yimian.com.cn/apps',
        },
        locked: false,
        forbid: false,
      };
    },
    methods: {
      login() {
        this.$refs.form.validate((valid) => {
          if (!this.form.username || !this.form.password) {
            Message('请填写用户名和密码');
            return;
          }

          if (valid) {
            this.$auth.login(this.form).then(() => {
              this.$router.push({ name: 'applications' });
            }).catch((res) => {
              const { err_code: errCode, reason } = res.body;
              if (errCode && reason) {
                this.$message.error(reason);
              } else {
                this.$message.error('Unknown. Please contact an administrator');
              }
            });
          }
        });
      },
      loginByWeixin() {
        this.$api.loginByWeixin(this.weixinParam)
          .then((res) => {
            window.location = res.data.url;
          })
          .catch((err) => {
            this.$message.error(err.body.data);
          });
      },
      redirectForgotPassword() {
        /* eslint-disable */
        const url = `${process.env.HAMLET_URL}/forgot_password?app_key=${process.env.APP_KEY}&callback_url=${document.location.href}`;
        window.location = url;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// Login.vue?4f78678c